<template>
  <v-form v-bind="this.$attrs">
    <v-row cols="12 " class="d-flex justify-end ma-2">
      <v-col cols="12" md="3">
        <AutocompleteTeacher
          :syncedValue.sync="teacher"
          v-model="teacher"
          return-object
          label="Giáo viên"
          outlined
          dense
          hide-details
          clearable
        />
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-btn class="search-button" @click="filter()" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher.vue'
import { mapActions } from 'vuex'
import get from 'lodash-es/get'

export default {
  data() {
    return {
      classes: null,
      teacher: null
    }
  },
  components: {
    AutocompleteTeacher
  },
  methods: {
    ...mapActions('teachers', ['searchTeachers']),
    async filter() {
      const params = {
        id: get(this.teacher, 'id')
      }
      await this.searchTeachers(params)
    }
  }
}
</script>

<style scoped>
.text {
  width: 154px;
  height: 20px;

  /* Body regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  /* identical to box height, or 143% */
  /* icon, sub */

  color: #797979;
}

.text-name {
  /* Toàn trường */
  width: 290px;
  height: 24px;

  /* H4 */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  /* identical to box height, or 133% */
  color: #000000;
}
</style>
